<template>
    <div class="campaign-item-page mt-2 mb-2" @click="clickCampaign()">
        <div class="campaign-item-wrapper">
            <div class="img"><img :src="campaign.fullImageUrl" class="card-img-top" /></div>
            <div class="campaign-item">
                <div class="ellipsis campaign-name">{{campaign.name}}</div>
                <!-- <p class="conditon-text" v-html="condition"></p> -->
                <p class="ellipsis-3 detail">{{campaign.condition}}</p>
                <div class="item-point">{{getPointMessage()}}</div>
            </div>
        </div>
        <div class="border-item"> <img src="@/assets/icon/line-2@3x.png"/> </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js"

import Util from '@/helper/Utility.js';

export default {
    name: 'CampaignItem',
    props: {
        lbl: Object,
        index: Number,
        campaign: Object,
        tracking: Object
    },
    data: function() {
        return {
            lblCampaign: this.lbl.campaign,
            condition: null,
        };
    },
    created: function() {

    },
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
        this.setTextCondition()
    },
    methods: {
        //event
        clickCampaign: function () {
            //GA
            //window.location.href = '/giftdetail/' + this.campaign.id;
            var path = '/giftdetail/' + this.campaign.id;
            this.$router.push(path);

            let trackCamp = this.campaign.id + "|" + this.campaign.name;
            this.tracking.event('Gift_List', 'click_Campaign_Gift_List', trackCamp);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        getPointMessage: function () {
            console.log("getPointMessage");
            //var pointType = this.campaign.pointType == 'get' ? this.lblCampaign.get_point : this.lblCampaign.use_point;
            // var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit != 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return Util.formatNum(this.campaign.pointPerUnit) + " " + pointUnit;
        },
        setTextCondition: function() {
            this.condition = Util.newLineToBr(this.campaign.condition);
        }
    },
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';

    .conditon-text{
        font-size: 0.9rem;
    }
    .campaign-item-page {

        .campaign-item-wrapper {
            @extend %display-flex-nowrap;

            .img {
                width: 40%;
            }
            .campaign-item {

                width: 60%;
                padding: 10px;
                padding-top: 0;

                .campaign-name {
                    font-size: 18px;
                    margin-top: 0;
                    margin-bottom: 10px;
                }
                .detail {
                    font-size: 15px;
                }
                .item-point{
                    padding-top: 20px;
                }
            }
        }
        .border-item {

            img {
                width: 100%;
            }
        }
    }

</style>
